import { render, staticRenderFns } from "./alias.vue?vue&type=template&id=4b19cb9f"
import script from "./alias.vue?vue&type=script&lang=js"
export * from "./alias.vue?vue&type=script&lang=js"
import style0 from "./alias.vue?vue&type=style&index=0&id=4b19cb9f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports